const line = [
    {
        id: 0,
        topic: 'Nhanh nhất',
        info: ' - GrabFood cung cấp dịch vụ giao đồ ăn nhanh nhất thị trường.'
    },
    {
        id: 1,
        topic: 'Dễ dàng nhất',
        info: ' - Giờ đây, bạn chỉ cần thực hiện vài cú nhấp chuột hoặc chạm nhẹ là đã có thể đặt đồ ăn. Hãy đặt đồ ăn trực tuyến hoặc tải xuống siêu ứng dụng Grab của chúng tôi để có trải nghiệm nhanh hơn và thú vị hơn.'
    },
    {
        id: 2,
        topic: 'Đáp ứng mọi nhu cầu',
        info: ' - Từ món ăn đặc sản địa phương đến các nhà hàng được ưa thích, nhiều lựa chọn đa dạng chắc chắn sẽ luôn làm hài lòng khẩu vị của bạn.'
    },
    {
        id: 3,
        topic: 'Thanh toán dễ dàng',
        info: ' - Giao và nhận đồ ăn thật dễ dàng. Thanh toán bằng GrabPay thậm chí còn dễ dàng hơn nữa.'
    },
    {
        id: 4,
        topic: 'Nhiều quà tặng hơn',
        info: ' - Tích điểm GrabRewards cho mỗi đơn hàng của bạn và sử dụng điểm thưởng để đổi lấy nhiều ưu đãi hơn.'
    }
]
export default line